import type { LowStock } from "../services/inventoryApi";

// This matches your LowStockControlsWeb UI shape
export type LowStockValue = {
  enabled: boolean;
  threshold: string;
  alertOnce: boolean;
  cooldownHours: string;
  channels: Array<"inapp" | "email" | "push">;
};

const PUSH: "push" = "push";
const ensurePush = (arr: LowStock["channels"] = []) =>
  arr?.includes(PUSH) ? arr : [PUSH, ...(arr ?? [])];

const toNum = (s: unknown): number | undefined => {
  if (s == null) return undefined;
  if (typeof s === "number" && Number.isFinite(s)) return s;
  const str = String(s).trim();
  if (str === "") return undefined;
  const v = Number(str);
  return Number.isFinite(v) ? v : undefined;
};

// Accepts either LowStockValue (UI) or LowStock-ish (already numbers/optional strings)
export const toApiLowStock = (
  v: Partial<LowStockValue> | Partial<LowStock> | undefined | null
): LowStock | undefined => {
  if (!v) return undefined;

  const enabled = !!(v as any).enabled;

  // Support both string and number inputs
  const threshold = toNum((v as any).threshold);
  const cooldownHours = toNum((v as any).cooldownHours);
  const alertOnce =
    (v as any).alertOnce === undefined ? true : !!(v as any).alertOnce;

  let channels = (v as any).channels as LowStock["channels"] | undefined;
  channels = enabled ? ensurePush(channels) : channels;

  return {
    enabled,
    threshold,
    alertOnce,
    cooldownHours,
    channels,
  };
};
